'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('searchDropdown', searchDropdown);

    function searchDropdown() {
        return {
            restrict: 'E',
            link: link,
            transclude: true,
            replace: true,
            scope: {
                dropdownName: '=',
                dropdownAlias: '=',
                dropdownContent: '=',
                dropdownIconInactive: '=',
                dropdownIconActive: '=',
                searchModel: '='
            },
            templateUrl: 'app/results/filters/search.dropdown.html'
        };

        function link(scope, iElement, iAttrs, searchModel) {

            scope.toggleDropdownBody = toggleDropdownBody;
            scope.hideDropdownBody = hideDropdownBody;
            scope.selectOption = selectOption;
            scope.showDropdownBody = false;
            scope.defaultValuesApplied = true;
            scope.selectedValue = scope.dropdownAlias == 'location' ? 'Beograd' : scope.searchModel[scope.dropdownAlias + '_label'];

            scope.$watch('searchModel', function () {
                scope.selectedValue = scope.searchModel[scope.dropdownAlias + '_label'];
            }, true);

            function hideDropdownBody() {
                scope.showDropdownBody = false;
            }

            function toggleDropdownBody() {
                scope.showDropdownBody = !scope.showDropdownBody;
            }

            function selectOption(key, value) {
                scope.searchModel[scope.dropdownAlias] = key;
                scope.searchModel[scope.dropdownAlias + '_label'] = value;
                toggleDropdownBody();
                scope.defaultValuesApplied = key == '-1' || key == '*' || !key || key == '0';
                scope.selectedValue = value;
            }
        }
    }
})();